import React from 'react';
import PropTypes from 'prop-types';

import CollectionPaginationButton from '../CollectionPaginationButton/CollectionPaginationButton';
import { IconArrow } from '../Icons';
import { getPaginationAry } from '../../Utils/CollectionUtils';
import { StyledDiv, StyledButton, StyledViewAllBtn } from './CollectionPaginationStyles';

var _ref = React.createElement(IconArrow, null);

var _ref2 = React.createElement(IconArrow, null);

var CollectionPagination = function CollectionPagination(props) {
  var getPageCount = function getPageCount() {
    var productCount = props.currentlyFiltered ? props.filteredProductCount : props.totalProductCount;
    var pageCount = Math.ceil(productCount / props.productsPerPage);
    return pageCount > 0 ? pageCount : 1;
  };

  var incrementPage = function incrementPage() {
    var pageCount = getPageCount();
    var lastPage = pageCount - 1;
    if (props.currentPageIndex < lastPage) {
      props.handlePaginationClick(props.currentPageIndex + 1, props.bottomPagination);
    }
  };

  var decreasePage = function decreasePage() {
    if (props.currentPageIndex > 0) {
      props.handlePaginationClick(props.currentPageIndex - 1, props.bottomPagination);
    }
  };

  var pageCount = getPageCount();
  var paginationAry = getPaginationAry(props.currentPageIndex, pageCount);

  return React.createElement(
    StyledDiv,
    { bottom: props.bottomPagination },
    React.createElement(
      StyledButton,
      {
        prev: true,
        onClick: decreasePage,
        'aria-label': 'Previous Page',
        'aria-disabled': props.currentPageIndex === paginationAry[0],
        disabled: props.currentPageIndex === paginationAry[0]
      },
      _ref
    ),
    props.bottomPagination && pageCount > 1 ? paginationAry.map(function (pageIndex, i) {
      return React.createElement(CollectionPaginationButton, {
        key: i,
        pageIndex: pageIndex,
        handlePaginationClick: props.handlePaginationClick,
        currentPageIndex: props.currentPageIndex,
        pageCount: pageCount
      });
    }) : props.currentPageIndex + 1 + ' / ' + pageCount,
    React.createElement(
      StyledButton,
      {
        onClick: incrementPage,
        'aria-label': 'Next Page',
        'aria-disabled': props.currentPageIndex + 1 === pageCount,
        disabled: props.currentPageIndex + 1 === pageCount
      },
      _ref2
    ),
    props.bottomPagination && props.totalProductCount > 24 && React.createElement(
      StyledViewAllBtn,
      {
        active: props.productsPerPage > 24,
        onClick: props.toggleViewAll
      },
      'View All'
    )
  );
};

CollectionPagination.propTypes = {
  handlePaginationClick: PropTypes.func.isRequired,
  productsPerPage: PropTypes.number.isRequired,
  currentPageIndex: PropTypes.number.isRequired,
  currentlyFiltered: PropTypes.bool.isRequired,
  filteredProductCount: PropTypes.number.isRequired,
  bottomPagination: PropTypes.bool,
  totalProductCount: PropTypes.number,
  toggleViewAll: PropTypes.func
};

export default CollectionPagination;